import moment from 'moment';
import TripStatusMixin from '@/mixins/TripStatusMixin'

export default {
    mixins: [TripStatusMixin],
    methods: {
        getFormattedDateRage(dateRange) {
            return moment(dateRange[0], 'MM-DD-YYYY').format('YYYY-MM-DD') +
                "," + moment(dateRange[1], 'MM-DD-YYYY').format('YYYY-MM-DD');
        },
        getUrl(from, to) {
            if (from && to) {
                return `/api/trips/search/${from}/${to}`;
            } else if (from || to) {
                return '/api/trips/search';
            }
        },
        getParams(from, to, dateRange) {
            let formattedDateRange = null;
            if (dateRange && dateRange.length > 0 && dateRange[0]) {
                formattedDateRange = this.getFormattedDateRage(dateRange);
            }

            if (this.pagination) {
                this.pagination.total = 0;
            }

            let params = {}

            if (dateRange == null || (dateRange[0] == null && dateRange[1] == null)) {
                params = {
                    params: {
                        email: this.email,
                        phone: this.phone,
                        include: ['passengersJoined'],
                        'filter[afterToday]': true,
                        sort: this.sort || this.defaultSort,
                    }
                };
            } else {
                params = {
                    params: {
                        email: this.email,
                        phone: this.phone,
                        'filter[afterToday]': true,
                        perPage: this.pagination ? this.pagination.perPage : 10,
                        page: this.pagination ? this.pagination.currentPage : 1,
                        sort: this.sort || this.defaultSort,
                    }
                };
            }

            if (from && to) {
                params = {
                    params: {
                        ...params.params,
                        ... {
                            'filter[between]': formattedDateRange,
                        }
                    }
                };
            } else if (from || to) {
                params = {
                    params: {
                        ...params.params,
                        ... {
                            'departureAirport': from,
                            'arrivalAirport': to,
                            'filter[between]': formattedDateRange,
                        }
                    }
                };
            }

            return params;
        },
        getFailedSearchParams(proposedParams) {
            let formattedDateRange = null;
            if (this.lastFetch.dateRange && this.lastFetch.dateRange.length > 0 && this.lastFetch.dateRange[0]) {
                formattedDateRange = this.getFormattedDateRage(this.lastFetch.dateRange);
            }

            let params = {
                flies_from: this.lastFetch.from,
                flies_to: this.lastFetch.to,
                email: proposedParams.formData.email,
                phone: proposedParams.formData.phone,
                date_range: formattedDateRange,
                status: this.getStatus(proposedParams.status),
            };

            return params;
        },
    }
}